import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NavMenu from '../layoutItems/navMenu';
import LeftPanel from '../layoutItems/leftPanel';
import MobileFooter from '../layoutItems/mobileFooter';
import MobileDockerMenu from '../layoutItems/mobileDockerMenu';
import SettingsDockerMenu from '../settings/settingsComponent';
import { withRouter } from "react-router";
import { withLocalize, Translate } from "react-localize-redux";
import { layoutActions } from '../../store/layoutStore';
import { userContextActions } from '../../store/userContextStore';
import Message from '../common/message';
import TopPanel from '../layoutItems/topPanel';
import RightPanel from '../layoutItems/rightPanel';
import { getScrollY } from '../../store/almightyElementWrapper';
import { chartActions } from '../../store/charts/chartsStore';

import "../layoutItems/layout.scss";

class ChartLayout extends React.Component {
    state = {
        scrollTop: 0,
        minusWidth: 0
    }

    UNSAFE_componentWillMount() {
        const that = this; // because of setInterval stupidity
        this.updaterInterval = window.setInterval(function () { that.updateScrollbar(); }, 500);
    }

    componentWillUnmount() {
        window.clearInterval(this.updaterInterval);
    }

    updateScrollbar = () => {
        const newY = getScrollY();
        if (this.state.scrollTop !== newY) {
            this.setState({ scrollTop: newY });
        }
    }

    render() {
        const tint = localStorage.locales_tint;
        return (
            <div className={classnames('grid-root')}>
                <LeftPanel tinted={tint === 'menu'} forceFixed={false} disableUpdate />
                <div className='main-content' style={{ paddingTop: this.props.user.authentication.limitedUser ? '0px' : null }}>
                    {!this.props.user.authentication.limitedUser &&
                        <div className="page-nav print-hidden" style={{ position: 'absolute' }}>
                            <NavMenu />
                        </div>
                    }
                    {this.renderScrollingContent(tint)}
                    <MobileFooter />
                </div>
                <div className='hide-on-desktop'>
                    <RightPanel tinted={tint === 'menu'} onWidthChange={(w, u) => this.resizeMain(w, u)} initialWidth={290} minimumWidth={290} />
                </div>
                <MobileDockerMenu />
                <SettingsDockerMenu scrollWidth={document.documentElement.clientWidth} />
            </div>
        );
    }

    renderScrollingContent = (tint) => {
        const Component = this.props.component;
        return (
            <div className={classnames('content-body-wrapper content-charts', { 'content-mobile-search': this.props.layout.topMenuExpanded })}>
                <TopPanel {...{ ...this.props.componentProps, tinted: tint === 'header' }} />
                <div className={`content-body ${this.props.pageClass || ''}`}>
                    <div className='page-content' style={{ width: 'calc(100% - ' + this.state.minusWidth + 'px' }}>
                        {this.props.error && this.renderError()}
                        <Component {...this.props.componentProps} {...this.props.children}></Component>
                    </div>
                    <div className='hide-on-mobile' style={{ display: 'flex' }}>
                        <RightPanel tinted={tint === 'menu'} onWidthChange={(w, u) => this.resizeMain(w, u)} initialWidth={290} minimumWidth={290} />
                    </div>
                </div>
            </div>
        );
    }

    getDisplaySettings(setting, defaultVal) {
        try {
            return this.props.user.authentication.profile.displaySettings[setting]
        } catch {
            return defaultVal;
        }
    }

    renderError = () => {
        return (
            <div className="error-container">
                <Message type={'warning'} message={<Translate id={this.props.error} options={{ renderInnerHtml: true }} />} />
            </div>
        );
    }

    resizeMain = (minusWidth, update) => {
        if (minusWidth !== null)
            this.setState({ minusWidth });
        if (update) {
            this.props.requestUpdate();
        }
    }
}

export default withLocalize(connect(
    state => { return { ...state.appContext, ...state.report, search: state.search, layout: state.layout, user: state.userContext }; },
    dispatch => bindActionCreators({ ...layoutActions, ...userContextActions, ...chartActions }, dispatch)
)(withRouter(ChartLayout)));